























import Vue from 'vue';
import {Component, Emit, Prop} from "vue-property-decorator";
import AsiContentContainer from "../common/AsiContentContainer.vue";
import Bill from "@/models/bill/Bill";
import BillCardBasicData from "@/components/bill/BillCardBasicData.vue";
import StateBar from "@/components/StateBar.vue";
import {enumToSelectItems} from "@/helpers/functions_asi";
import {BillState, Permissions} from "@/helpers/constants";
import CardBlamable from "@/components/CardBlamable.vue";
import BillCardSendLogs from "@/components/bill/BillCardSendLogs.vue";
import {Icon} from "@/helpers/icons";
import AsiFadeTransition from "@/components/common/AsiFadeTransition.vue";
import AsiAlert from "@/components/common/AsiAlert.vue";
import BillCardAdditionalInfos from "@/components/bill/BillCardAdditionalInfos.vue";
import BillCardIsPaid from "@/components/bill/BillCardIsPaid.vue";

@Component({
	components: {
		BillCardIsPaid,
		BillCardAdditionalInfos,
		AsiAlert,
		AsiFadeTransition,
		BillCardSendLogs, CardBlamable, StateBar, BillCardBasicData, AsiContentContainer
	}
})
export default class BillTabDetails extends Vue {

	@Prop({type: Object, required: true})
	public bill!: Bill;

	@Prop({type: Boolean, default: true})
	public hasEnoughBillingInformation!: boolean;

	private icons = Icon;
	private billStates = enumToSelectItems(BillState, true);

	private get isInternal(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightInternal);
	}

	private get isOffice(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightOffice);
	}

	private get isBilling(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightBilling);
	}

	@Emit('billChanged')
	public billChanged(event: Event): Event {
		return event;
	}

}
